import {User} from "../user/user";
import {ProjectRole} from "../role/role";
export class Structures {
  Data: Structure[];
  Count: number;
}

export class Structure {
  Id?: number;
  Uid?: string;
  MyDocmaUid?: string;
  SUid?: string;
  UniqueId?: string;
  Name1?: string;
  Name2?: string;
  Level?: number;
  Low?: number;
  High?: number;
  isActive?: boolean;
  HasChildren?: boolean;
  Parent?: Structure;
  Children?: Structure[] = [];
  RootId?: number;
  StructurePath?: string;
  StructurePathShort?: string;
  StructurePathLong?: string;
  StructureSortId?: number;
  selectable?: boolean;
  hidden?: boolean;

  constructor(structure: Partial<Structure>) {
    if (structure) {
      Object.assign(this, structure);
      if (structure.Parent) {
        this.Parent = new Structure(this.Parent);
      }
      if (structure.Children) {
        this.Children = structure.Children.map(c => new Structure(c));
      }
    }
  }

  findById(id: number): Structure {
    if (this.Id === id) {
      return this;
    }
    if (this.Children) {
      for (const s of this.Children) {
        const found = s.findById(id);
        if (found) {
          return found;
        }
      }


    }
    return null;
  }

  getFlatSortedStructures(): Structure[] {
    const structures = [this];
    this.Children.forEach(childs => this.getChilds(childs, structures));
    return structures;
  }

  private getChilds(struct: Structure, structList: Structure[]) {
    structList.push(struct);
    struct.Children.forEach(childs => this.getChilds(childs,structList));
  }
}

export class StructureCategories {
  Data: StructureCategory[];
  Count: number;
}

export class StructureCategory {
  Id?: number;
  Uid: string;
  Name: string;
  Description: string;
}

export class StructurePermissions {
  Data: StructurePermission[];
  Count: number;
}

export class StructurePermission {
  Id?: number;
  User: User;
  Structure: Structure;
  Role: ProjectRole;
}

export class StructureTree extends Structure {
  Expand?: boolean = false;
}

export function flattenStructure(arr: Structure[]) {
  const result: Structure[] = [];
  arr.forEach(st => {
    result.push(st);
    if ((st.Children?.length ?? 0) > 0)
      result.push(...flattenStructure(st.Children));
  });
  return result;
}
